import VueCookies from "vue-cookies";
import { bus } from "@/main";
import { getProjectsList } from "@/data/models/project.model";
import { getSchoolsList } from "@/data/models/school.model";

export default {
	name: "HomePage",
	data() {
		return {
			intro: [
				"Integrada no Projeto Escolas, a Exposição Y: Desenhar Portugal será o vórtice nuclear deste Projeto evidenciando, através da cultura das várias Escolas, novas oportunidades para o design orientadas por dois princípios: propondo soluções novas para problemas antigos (licenciatura e mestrado) e gerando novos problemas, dando origem a novos domínios ao design (doutoramento) – elegendo o território de inserção das Escolas, sob a perspectiva da sua valorização.",
				"Os projectos submetidos deverão cumprir um papel representacional do pensamento estratégico de cada escola sobre o design e o seu impacto social, económico cultural (…) insere. Deduzindo que as escolas elegerão os projectos a expor de acordo com a afirmação da sua estratégia pedagógica, solicitamos a partilha da reflexão subjacente ao seu quadro de referências, a fim de evidenciar a sua singularidade entre pares."
			],
			loginIntro: [
				"O Projeto Escolas pretende constituir - se como um laboratório de reflexão e de inovação em Design, em vários domínios: a experiência educativa nacional em Design ao serviço da sociedade, da economia e da cultura, ensaiando e antecipando novas soluções a partir da observação local.Integrada no Projeto Escolas, a Exposição Y: Desenhar Portugal, a inaugurar em Novembro de 2019, na Galeria Municipal(Matosinhos) deverá ser o vórtice nuclear deste Projeto.",
				"Cada escola poderá apresentar até 3 trabalhos em cada um dos 3 ciclos de estudo — licenciatura, mestrado e doutoramento — cumprindo o pressuposto de que tenham sido realizados nos três últimos anos lectivos(2016 - 17 / 2017 - 18 / 2018 - 19).A data limite para o upload destes trabalhos é o dia 28 de junho de 2019 até às 24h00.",
				"Os projetos internamente selecionados por cada escola serão expostos na Porto Design Biennale, cabendo à curadoria o seu tratamento, articulação temática e a eventual proposta de desenvolvimento de suportes complementares de comunicação e / ou prototipagem."
			],
			projects: [],
			schools: [],
			isReadyProjects: false,
			isReadySchools: false,
			isLoading: true,
			user: null,
		}
	},
	created() {
		this.user = VueCookies.get("user");
		this.getContent()
		bus.$on("deleteSession", () => {
			this.projects = null
			this.schools = null
			this.getContent();
		})
		bus.$on("userSession", () => {
			this.getContent();
		})
	},
	computed: {
		pageUrl: function() {
			return location.href;
		}
	},
	watch: {
		"$route": function() {
			this.getContent();
			this.user = VueCookies.get("user");
		}
	},
	methods: {
		async getContent() {
			let user = VueCookies.get("user");
			if (user && (user.username == "admin" || user.username == "projetoescolas" ) ) { 
				await getProjectsList(2).then(content => {
					this.projects = content;
					this.isReadyProjects = true;
				})
				await getSchoolsList(2).then(content => {
					this.schools = content;
					this.isReadySchools = true;
				})
				this.isLoading = false;
			} else if (user) {
				await getProjectsList(2, 1, user.id).then(content => {
					this.projects = content;
					this.isReadyProjects = true;
				})
				await getSchoolsList(2, 1, user.id).then(content => {
					this.schools = content;
					this.isReadySchools = true;
				})
				this.isLoading = false;
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/home/home.page.js